/**
 * The semantic type roles of the shared theme (Product Brand Guide §5): the
 * `text-<role>` utilities `theme.css` declares, smallest last, then the two
 * dense-table roles. Listed here so the class-name merge knows they are font
 * sizes; the theme token test holds this list equal to the theme's declarations.
 */
export const TYPE_ROLES = [
    'display-xl',
    'display-lg',
    'display-md',
    'page-title',
    'product-title',
    'section-title',
    'body',
    'caption',
    'label',
    'table',
    'table-secondary',
];
//# sourceMappingURL=type-roles.js.map